const ALL_VEHICLES_GROUP = 'swt-vehicles';


export function formatDateParamsForApi(date) {
    return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
}

export const sawatchApiFetchCall = (user, dataProcessingFunction) => {
    // Returns a generic fetch function
    return async (url) => {
        if (!user || !user.token) {
            console.error('Missing authentication token.');
            throw new Error('Authentication token is missing.');
        }
        try {
            const response = await fetch(url, {
                headers: { Authorization: `Bearer ${user.token}` },
            });
            if (!response.ok) {
                const errorData = await response.json().catch(() => ({ message: response.statusText }));
                const error = new Error(`API call failed: ${response.status} - ${errorData.message || 'Unknown error'}`);
                error.status = response.status;
                throw error;
            }
            // If we were provided with a processing function for further early-stage processing, run it, otherwise just return the internal data value via the generic 'processing' function
            const rawData = await response.json();
            return dataProcessingFunction ? dataProcessingFunction(rawData) : genericProcessingFunction(rawData);
        } catch (error) {
            console.error('Error in fetch call:', error);
            throw error;
        }
    };
};

function genericProcessingFunction(rawData) {
    // No actual processing needed, just extracting the internal 'data' object for efficiency
    return rawData?.data ?? [];
}

export const fetchVehicleClasses = (user) => {
    function processVehicleClassesData(rawData) {
        if (rawData?.data?.length > 0) {
            // TODO: we filter equipment out of the raw vehicle data - should we filter equipment out of the class list as well? If this class is represented in the DB, currently it will be shown in the class dropdown and selecting it results in no data being displayed. -NK
            return rawData.data.filter(d => d.vehicle_class !== '' && d.vehicle_class !== null)
                .map(e => e.vehicle_class);
        }
        return [];
    }

    return sawatchApiFetchCall(user, processVehicleClassesData);
}

export const fetchGroups = (user) => {
    function processGroupsData(rawData) {
        if (rawData?.data) {
            const groups = [...rawData.data];
            const idx = groups.findIndex(g => g.id === ALL_VEHICLES_GROUP);
            if (idx > -1) {
                const obj = groups[idx];
                groups.splice(idx, 1);
                groups.unshift(obj);
            }
            return groups;
        }
        return [];
    }

    return sawatchApiFetchCall(user, processGroupsData);
}

export const fetchDateBounds = (user) => {
    function processBoundsData(rawData) {
        if (rawData?.data?.length > 0) {
            const begin = new Date(rawData.data[0].min);
            const end = new Date(rawData.data[0].max);
            return { beginDate: begin, endDate: end };
        }
        return null;
    }

    return sawatchApiFetchCall(user, processBoundsData);
}

export const fetchDbSettings = (user) => {
    function processDbSettingsData(rawData) {
        if (rawData?.data?.length > 0) {
            return rawData.data[0]; // Return the first (most recent) settings object
        }
        return {};
    }

    return sawatchApiFetchCall(user, processDbSettingsData);
}

export const fetchVehicleData = (user) => {

    function processVehicleData(rawData) {
        // Filter out equipment, and any vehicles with an 'undefined' class.
        // /TODO: Check if vehicles can still even have an undefined class - the latter check might be unnecessary now? -NK
        if (rawData?.data?.length > 0) {
            return rawData.data.filter(v => (
                typeof v.vehicle_class !== 'undefined' &&
                v.vehicle_class !== 'Equipment'
            ));
        }
        return [];
    }

    return sawatchApiFetchCall(user, processVehicleData);
}

export const fetchGraphData = (user) => {
    function processGraphData(rawData) {
        // NOTE: I'm not sure the check that at least one day has a fuel value & distance value above 0 is needed, but including it here for completeness. -NK
        // Original comment on this section of code was from Jake in Aug '22: "These checks should be reviewed in the future once the API ep is updated and returns a single response type when there is no data."
        if (rawData?.data?.length > 0 && !(rawData.data.every((d) => d.fu_liters === 0 && d.km === 0))) {
            return rawData.data;
        }
        return [];
    }

    return sawatchApiFetchCall(user, processGraphData);
}